import { render } from "./articleCreat.vue?vue&type=template&id=3943fd9e&scoped=true"
import script from "./articleCreat.vue?vue&type=script&lang=js"
export * from "./articleCreat.vue?vue&type=script&lang=js"

import "./articleCreat.vue?vue&type=style&index=0&id=3943fd9e&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3943fd9e"]])

export default __exports__